module.exports = __webpack_public_path__ + "img/home.7a90c585.svg";